// extracted by mini-css-extract-plugin
module.exports = {"reportHeaderTitle":"KUgUBXYs","reportHeaderDateRange":"_2PeLkpm4"};